module.exports = __webpack_public_path__ + "static/media/SavedLocationIcon.97a1070d.png";